<template>
  <div class="row d-flex vh-100 justify-content-center">
    <div class="col-4">
      <div id="buscador" class="form login">
        <form v-on:submit.prevent="login">
          <div class="row mb-1">
            <h5>Acceso Alerce Web</h5>

            <label class="mb-3">Ingresa sus datos de acceso</label>
            <!-- Mensaje de login (local o del padre) -->
            <div v-if="displayLoginMessage" class="alert alert-danger mb-3">
              {{ displayLoginMessage }}
            </div>

            <div class="col-12 mb-3">
              <div class="input-group mb-1">
                <span class="input-group-text" id="basic-addon1"><i class="bi bi-person"></i></span>
                <input
                  type="text"
                  class="form-control"
                  v-model="user"
                  placeholder="Username"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                />
              </div>
            </div>

            <div class="col-12 mb-3">
              <div class="input-group mb-1">
                <span class="input-group-text" id="basic-addon1"><i class="bi bi-key"></i></span>
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  placeholder="Password"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                />
              </div>
            </div>

            <div class="col-12 d-grid">
              <button class="btn btn-secondary" id="campos" type="submit">Ingresar</button>
            </div>


          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
// Recibe mensaje de login del padre
const props = defineProps<{ loginMessage?: string }>()
import { useAuthStore } from '../stores/t-auth'
import API from '../services'

import { useGlobalStore } from '../stores/global'

const auth = useAuthStore()
const user = ref('')
const password = ref('')
const errorMessage = ref('')
// Prioriza el mensaje local, si no existe muestra el del padre
const displayLoginMessage = computed(() => {
  return errorMessage.value || props.loginMessage || ''
})

const emit = defineEmits<{
  (event: 'cargado'): void
}>()
async function login() {
  const resp = await auth.login(user.value, password.value)
  console.log(resp)
  if (resp) {
    if(await API.checkPermiso('LOGIN_ALERCEWEB')){
      // Verificar rol PATRULLA y llamar a la API
      const roles = auth.userParams?.Usuario?.roles ?? [];
      const username = auth.userParams?.Usuario?.user_name;
      if (roles.includes('PATRULLA') && username) {
        const global = useGlobalStore();
        try {
          const missionResp = await API.getMissionByPilot(username);
          // Guardar mission en patrulla.activeMission
          global.patrulla.activeMission = missionResp.data?.Entries?.Entry?.mission ?? 0;
          global.patrulla.unitId = missionResp.data?.Entries?.Entry?.unit_id ?? '';
          // Verificar permiso y guardar en patrulla.reportCoords
          global.patrulla.reportCoords = await API.checkPermiso("REPORT_COORDS");
          global.patrulla.useApp = await API.checkPermiso("USE_ALERCE_APP");
          
          console.log('Misiones del piloto:', missionResp.data);
        } catch (err) {
          console.error('Error obteniendo misiones del piloto', err);
        }
      }
      emit('cargado')
    }
    else{
      console.log('no tiene permiso')
      errorMessage.value = 'El usuario no tiene permisos para acceder a Alerce Web'
    }
  } else {
    console.log('error')
    errorMessage.value = 'Los Datos ingresados son incorrectos'
  }
}
</script>
<style scoped>
@media (max-width: 576px) {
  .col-4 {
    width: 80vw;
  }
}
</style>
